import React, {ReactNode} from "react";

import './PortalPage.scss';
import AlertStack from "./shared/AlertStack";

interface Props {
  title?: string,
  className?: string,
  children?: ReactNode
}

type State = {}

class PortalPage extends React.Component<Props, State> {
  render() {
    return (
      <div className={`portal-page ${this.props.className || ''}`}>
        {this.props.children}
        <AlertStack/>
      </div>
    )
  };
}

export default PortalPage;
